import { render, staticRenderFns } from "./CoursesOverview.vue?vue&type=template&id=7d610bf6&"
import script from "./CoursesOverview.vue?vue&type=script&lang=js&"
export * from "./CoursesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports